import React, {useState, useEffect} from "react"
import Benefits from "../Benefits"

function CustomizeBenefits({activity, regionCode}) {
  const [activityVariant, setActivityVariant] = useState(null)
  
  // activity or region change
  useEffect(() => {
    const av = activity.regionVariants.find(rv => rv.regionCode === regionCode)
    setActivityVariant(av)
  }, [activity, regionCode])

  // render
  if(!activityVariant) {
    return null
  }
  else {
    return <Benefits activityVariant={activityVariant} showInlineHelp={false} hideTitle={true} />
  }
}

export default CustomizeBenefits